export const scrollToInitialScroll = () => {
    const initialScrollEls = document.querySelectorAll('[data-initial-scroll]');
    if (initialScrollEls.length > 0) {
        window.scrollTo(0, initialScrollEls[0].offsetTop || 0);
    }
};
